import React from 'react'
import { Button } from '@fluentui/react-components'
import { ModalActions } from '../../common/modal/Modal'
import { Text } from '../../common/text/Text'
import { t } from '../../../i18n/i18n'
import { DraggableModal } from '../../common/modal/DraggableModal'

type ModalResetDecisionProps = {
   open: boolean
   close: () => void
   onConfirm: () => Promise<void>
   isSubmitting: boolean
}
export const ModalResetDecision = ({ open, close, onConfirm, isSubmitting }: ModalResetDecisionProps) => {
   return (
      <DraggableModal title={t('ResetDecision')} open={open} onClose={close} noDivider>
         <Text>{t('ResetDecisionConfirmationMessage')}</Text>
         <ModalActions>
            <Button onClick={close} disabled={isSubmitting}>
               {t('Cancel')}
            </Button>
            <Button appearance="primary" onClick={onConfirm} disabled={isSubmitting}>
               {t('ResetDecision')}
            </Button>
         </ModalActions>
      </DraggableModal>
   )
}
